/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

/* eslint-disable @typescript-eslint/no-require-imports */
if (typeof window !== 'undefined') {
  const originalConsoleError = console.error;
  Object.defineProperty(console, 'error', {
    value: function (...args: any[]) {
      const message = args.map(arg => {
        if (typeof arg === 'string') return arg;
        if (arg && typeof arg === 'object') {
          return arg.message || arg.toString() || '';
        }
        return String(arg);
      }).join(' ');

      if (message.includes('ResizeObserver loop') ||
        message.includes('ResizeObserver loop completed with undelivered notifications')) {
        return;
      }
      originalConsoleError.apply(console, args);
    },
    writable: true,
    configurable: true
  });

  const originalConsoleWarn = console.warn;
  Object.defineProperty(console, 'warn', {
    value: function (...args: any[]) {
      const message = args.map(arg => {
        if (typeof arg === 'string') return arg;
        if (arg && typeof arg === 'object') {
          return arg.message || arg.toString() || '';
        }
        return String(arg);
      }).join(' ');

      if (message.includes('ResizeObserver loop') ||
        message.includes('ResizeObserver loop completed with undelivered notifications')) {
        return;
      }
      originalConsoleWarn.apply(console, args);
    },
    writable: true,
    configurable: true
  });

  const originalOnError = window.onerror;
  window.onerror = function (message, source, lineno, colno, error) {
    if (typeof message === 'string' &&
      (message.includes('ResizeObserver loop') ||
        message.includes('ResizeObserver loop completed with undelivered notifications'))) {
      return true;
    }
    if (originalOnError) {
      return originalOnError.call(this, message, source, lineno, colno, error);
    }
    return false;
  };

  window.addEventListener('unhandledrejection', (event) => {
    const errorMessage = event.reason?.message || event.reason?.toString() || '';
    if (errorMessage.includes('ResizeObserver loop') ||
      errorMessage.includes('ResizeObserver loop completed with undelivered notifications')) {
      event.preventDefault();
    }
  }, true);
}

// The most part of content herebelow were copied from polyfills.ts file generated by @angular/cli
/**
 * This file includes polyfills needed by Angular and is loaded before the app.
 * You can add your own extra polyfills to this file.
 *
 * This file is divided into 2 sections:
 *   1. Browser polyfills. These are applied before loading ZoneJS and are sorted by browsers.
 *   2. Application imports. Files imported after ZoneJS that should be loaded before your main
 *      file.
 *
 * The current setup is for so-called "evergreen" browsers; the last versions of browsers that
 * automatically update themselves. This includes Safari >= 10, Chrome >= 55 (including Opera),
 * Edge >= 13 on the desktop, and iOS 10 and Chrome on mobile.
 *
 * Learn more in https://angular.io/docs/ts/latest/guide/browser-support.html
 */

/******************************************************************
 * Load `$localize` - used if i18n tags appear in Angular templates.
 */
import '@angular/localize/init';
import '@angular/compiler';

/***************************************************************************************************
 * BROWSER POLYFILLS
 */

/** IE9, IE10 and IE11 requires all of the following polyfills. (core-js 3 paths: es6 → es) **/
import 'core-js/es/symbol';
import 'core-js/es/object';
import 'core-js/es/function';
import 'core-js/es/parse-int';
import 'core-js/es/parse-float';
import 'core-js/es/number';
import 'core-js/es/math';
import 'core-js/es/string';
import 'core-js/es/date';
import 'core-js/es/array';
import 'core-js/es/regexp';
import 'core-js/es/map';
import 'core-js/es/weak-map';
import 'core-js/es/set';

/** IE10 and IE11 requires the following for NgClass support on SVG elements */
// import 'classlist.js';  // Run `npm install --save classlist.js`.

/** IE10 and IE11 requires the following for the Reflect API. */
import 'core-js/es/reflect';

/**
 * Web Animations `@angular/platform-browser/animations`
 * Only required if AnimationBuilder is used within the application and using IE/Edge or Safari.
 * Standard animation support in Angular DOES NOT require any polyfills (as of Angular 6.0).
 **/
// import 'web-animations-js';  // Run `npm install --save web-animations-js`.

/**
 * By default, zone.js will patch all possible macroTask and DomEvents
 * user can disable parts of macroTask/DomEvents patch by setting following flags
 */

// (window as any).__Zone_disable_requestAnimationFrame = true; // disable patch requestAnimationFrame
// (window as any).__Zone_disable_on_property = true; // disable patch onProperty such as onclick
// (window as any).__zone_symbol__BLACK_LISTED_EVENTS = ['scroll', 'mousemove']; // disable patch specified eventNames

/*
* in IE/Edge developer tools, the addEventListener will also be wrapped by zone.js
* with the following flag, it will bypass `zone.js` patch for IE/Edge
*/
// (window as any).__Zone_enable_cross_context_check = true;

/***************************************************************************************************
 * Zone JS is required by default for Angular itself.
 */
import 'zone.js';  // Included with Angular CLI.

/***************************************************************************************************
 * APPLICATION IMPORTS
 */

import svg4everybody from 'svg4everybody';

svg4everybody();

if ((<any>process.env.IE11_DEV_MODE) === true) {
  // This is a fix of zone.js-related problem occured only in Development Mode
  // https://github.com/angular/zone.js/issues/933
  (window as any).__Zone_enable_cross_context_check = true;
}

if ('production' === process.env.NODE_ENV) {
  // Production

} else {
  // Development

  Error.stackTraceLimit = Infinity;
  require('zone.js/plugins/long-stack-trace-zone');
}

// in order to support IE11 and Edge <= 14
// https://github.com/angular/angular/issues/24769
Element.prototype.matches = Element.prototype.matches || Element.prototype['msMatchesSelector'];
